import React, { useRef, useEffect, useState } from 'react';
import { Footer, Header, Sidebar } from "./index";
import Hero from './Hero';

const Layout = ({ children, heroProps, showSidebar, showFooter = true }) => {
    const heroRef = useRef(null);
    const [headerHeight, setHeaderHeight] = useState(0);

    useEffect(() => {
        // Fonction pour calculer la hauteur du header
        const updateHeaderHeight = () => {
            const headerElement = document.getElementById('main-header');
            if (headerElement) {
                const height = headerElement.offsetHeight;
                setHeaderHeight(height);
            }
        };

        // Initial calculation
        updateHeaderHeight();

        // Recalculate on window resize
        window.addEventListener('resize', updateHeaderHeight);

        // Cleanup
        return () => {
            window.removeEventListener('resize', updateHeaderHeight);
        };
    }, []);

    return (
        <div className="flex flex-col min-h-screen">
            <Header />

            {/* Hero Section */}
            {heroProps && (
                <div ref={heroRef} className="w-full">
                    <Hero {...heroProps} />
                </div>
            )}

            {/* Main Content with Sidebar */}
            <div className="flex flex-1 relative">
                {showSidebar && (
                    <>
                        {/* Version desktop du Sidebar (sticky après le header) */}
                        <div
                            className="xl:block hidden"
                            style={{
                                position: 'sticky',
                                top: `${headerHeight}px`,
                                height: `calc(100vh - ${headerHeight}px)`,
                                alignSelf: 'flex-start',
                                overflowY: 'hidden'
                            }}
                        >
                            <Sidebar headerHeight={headerHeight} />
                        </div>

                        {/* Version mobile du Sidebar */}
                        <div className="xl:hidden block">
                            <Sidebar headerHeight={headerHeight} />
                        </div>
                    </>
                )}

                {/* Main Content */}
                <main className="flex-1">
                    {children}
                </main>
            </div>

            {showFooter &&
                (<Footer />)
            }
        </div>
    );
};

export default Layout;